
import React, { Component } from 'react';
import * as ChartModuleMore from 'highcharts/highcharts-more.js';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import LinearProgress from '@material-ui/core/LinearProgress';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FadeIn from 'react-fade-in';
import Tooltip from '@material-ui/core/Tooltip';

import HCSoldGauge from 'highcharts/modules/solid-gauge';
import Highcharts from 'highcharts'
ChartModuleMore(Highcharts);
HCSoldGauge(Highcharts);

class Chart extends Component {
	constructor() {
		super();
		this.state = {
			data: null
		}
	}
	componentDidMount() {
		Alert.Loading(true)
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_3, {}, ({ datas }) => {
			this.setState({
				data: datas
			}, () => {
				Alert.LoadingClose()
			})
		})
	}
	renderLabelData(name, count, value, old_value, isPass = false, middle = false) {
		var _value = value
		return <div>
			<GridContainer justify="center">
				<GridItem xs={6}>
					{
						(middle) ?
							<Typography variant="body2" align="left" className={"linearProgress-c-gy-txt"} >{this.renderTooltip(name)}</Typography>
							:
							(isPass) ?
								<Typography variant="body2" align="left" className={"linearProgress-c-gn-txt"} >{this.renderTooltip(name)}</Typography>
								:
								<Typography variant="body2" align="left" className={"linearProgress-c-r-txt"}>{this.renderTooltip(name)}</Typography>
					}
				</GridItem>
				<GridItem xs={1}>
					{
						(middle) ?
							<Typography variant="body2" align="right" className={"linearProgress-c-gy-txt"} >N:{count}</Typography>
							:
							(isPass) ?
								<Typography variant="body2" align="right" className={"linearProgress-c-gn-txt"} >N:{count}</Typography>
								:
								<Typography variant="body2" align="right" className={"linearProgress-c-r-txt"}>N:{count}</Typography>
					}
				</GridItem>
				<GridItem xs={2}>
					<Box display="flex" alignItems="center">
						<Box width="100%" mr={1}>
							{
								(middle) ?
									<LinearProgress variant="determinate" className={"linearProgress-c-gy"} valueBuffer={_value} value={_value} />
									:
									(isPass) ?
										<LinearProgress variant="determinate" className={"linearProgress-c-gn"} valueBuffer={_value} value={_value} />
										:
										<LinearProgress variant="determinate" className={"linearProgress-c-r"} valueBuffer={_value} value={_value} />
							}

						</Box>
						<Box minWidth={35}>
							{
								(middle) ?
									<Typography variant="body2" className={"linearProgress-c-gy-txt"} align="right">{`${Math.round(_value)}%`}</Typography>
									:
									(isPass) ?
										<Typography variant="body2" className={"linearProgress-c-gn-txt"} align="right">{`${Math.round(_value)}%`}</Typography>
										:
										<Typography variant="body2" className={"linearProgress-c-r-txt"} align="right">{`${Math.round(_value)}%`}</Typography>
							}
						</Box>
					</Box>
				</GridItem>
				<GridItem xs={3}>
					<GridContainer justify="center">
						<GridItem><Typography variant="body2" align="right" >{Math.round(0)}%</Typography></GridItem>
						<GridItem><Typography variant="body2" align="right" >{Math.round(0)}%</Typography></GridItem>
						<GridItem><Typography variant="body2" align="right" >{Math.round(0)}%</Typography></GridItem>
					</GridContainer>
				</GridItem>
			</GridContainer>
		</div>
	}
	renderTooltip = (str) => {
		var _str = str
		// if (str.length > 20) {
		// 	_str = str.substring(0, 20) + "..."
		// }
		return (
			<Tooltip title={str} arrow placement="top">
				<div>{_str}</div>
			</Tooltip>
		)
	}
	render() {
		return (
			<div className={"p-1 chart-box"}>
				<div >
					<GridContainer justify="center">
						<GridItem xs={9} className="m-b-1">
							<h4 className="m-t-0"><b>Top 10 (% NPS OS)</b></h4>
						</GridItem>
						<GridItem xs={3}>
							<GridContainer justify="center">
								<GridItem> 3/FY21 </GridItem>
								<GridItem> 4/FY21 </GridItem>
								<GridItem> 1/FY21 </GridItem>
							</GridContainer>
						</GridItem>
					</GridContainer>
					{
						this.state.data && this.state.data.length > 10 ?
							<small className="txt-c-dorg">*เนื่องจากมีสาขาที่ได้ 100% เกิน 10 สาขา จึงแสดงทั้งหมดที่ได้ 100% เต็ม</small>
							: null
					}
					{
						this.state.data != null ?
							<FadeIn>
								{this.state.data.map((row) => {
									return this.renderLabelData(row.name, row.count_100_per, row.nps_os, row.nps_os, true)
								})}
							</FadeIn>
							: null
					}
				</div>
			</div>
		);
	}
}

export default Chart;